import { useAppSelector } from 'hooks/useAppSelector';
import { Divider } from 'layouts/main/sp-header/navigation/components/divider';
import { DropdownSectionTitle } from 'layouts/main/sp-header/navigation/components/dropdown-section-title';
import { NavigationDropdown } from 'layouts/main/sp-header/navigation/NavigationDropdown';
import {
  ConnectedAdvancedWorkspaceItem,
  ConnectedBatchWorkspaceItem,
  ConnectedDynamicWorkspaceItem,
  ConnectedEssentialWorkspaceItem,
  ConnectedSecondaryMarketBatchWorkspaceItem,
  ConnectedSmartQuoteWorkspaceItem,
  ConnectedSPLabItem,
  SecondaryMarketQuoteWorkspaceItem,
} from 'layouts/main/sp-header/navigation/workspaces-items';
import { createSelector } from 'reselect';
import type { RoutePath } from 'state/router';
import {
  isAdvancedWorkspaceVisible,
  isBatchWorkspaceVisible,
  isDynamicWorkspaceVisible,
  isEssentialWorkspaceVisible,
  isSecondaryQuoteEnabled,
  isSmartQuoteWorkspaceVisible,
  isSPLabVisible,
} from 'state/selectors/common/router';

const associatedRoutes: RoutePath[] = [
  '/smart-quote',
  '/essential',
  '/static',
  '/dynamic',
  '/batch',
  '/secondary-market-quotes-workspace',
];

const isPrimarySectionVisibleSelector = createSelector(
  isSmartQuoteWorkspaceVisible,
  isEssentialWorkspaceVisible,
  isAdvancedWorkspaceVisible,
  isDynamicWorkspaceVisible,
  isBatchWorkspaceVisible,
  isSPLabVisible,
  (smartQuote, essential, advanced, dynamic, batch, spLab) =>
    smartQuote || essential || advanced || dynamic || batch || spLab,
);

const isVisibleSelector = createSelector(
  isPrimarySectionVisibleSelector,
  isSecondaryQuoteEnabled,
  (isPrimary, isSecondary) => isPrimary || isSecondary,
);

export function WorkspacesMenu() {
  const isPrimarySectionVisible = useAppSelector(isPrimarySectionVisibleSelector);
  const isSecondarySectionVisible = useAppSelector(isSecondaryQuoteEnabled);
  const isVisible = useAppSelector(isVisibleSelector);

  return (
    <NavigationDropdown
      associatedRoutes={associatedRoutes}
      isVisible={isVisible}
      e2e="workspaces-menu"
      toggleE2e="workspaces-dropdown-toggle"
      menuE2e="workspaces-dropdown-menu"
      label="appHeader.navigation.workspaces"
    >
      {isPrimarySectionVisible && (
        <>
          <DropdownSectionTitle title="primaryMarket" />
          <ConnectedSmartQuoteWorkspaceItem />
          <ConnectedEssentialWorkspaceItem />
          <ConnectedAdvancedWorkspaceItem />
          <ConnectedDynamicWorkspaceItem />
          <ConnectedBatchWorkspaceItem />
          <ConnectedSPLabItem />
        </>
      )}
      {isPrimarySectionVisible && isSecondarySectionVisible && <Divider />}
      {isSecondarySectionVisible && (
        <>
          <DropdownSectionTitle title="secondaryMarket" />
          <SecondaryMarketQuoteWorkspaceItem />
          <ConnectedSecondaryMarketBatchWorkspaceItem />
        </>
      )}
    </NavigationDropdown>
  );
}
